/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import {Type} from "@qwoach/class-transformer-wrapper";
import DbBaseObject from "@shared/DbBaseObject";
import QwoachFile from "@shared/Drive/QwoachFile";
import {BookEntryTypeEnum} from "@shared/BookWriting/BookEntryTypeEnum";
import {BookSourceTypeEnum} from "@shared/BookWriting/BookSourceTypeEnum";
import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum";

export default class BookContentItem extends DbBaseObject {

	bookId: string = null
	clientId: string = null
	clientName: string = null
	entryType: BookEntryTypeEnum = BookEntryTypeEnum.CONTENT
	childName: string = null
	title: string = null
	subtitle: string = null
	chapterLabel: string = null
	isChapterLabelCustom: boolean = false
	dateRangeArray: number[] = []
	workingTitle: string = null
	isWorkingTitleCustom: boolean = false
	contentHtml: string = null

	@Type(() => QwoachFile)
	attachmentsArray: QwoachFile[] = []
	thumbRetryById: object = {}

	sourceType: BookSourceTypeEnum = BookSourceTypeEnum.MANUAL
	sourceSessionEntryId: string = null
	linkedSessionEntryId: string = null
	sourceSessionDateMs: number = null
	sourceSessionNumber: string = null
	sourceSessionTitle: string = null
	capturedAt: number = null
	clearanceLevel: ClearanceLevelEnum = ClearanceLevelEnum.PHI

	constructor(options = {}) {
		super(options);
		this.applyOptions(options);
	}

}
